export default __webpack_public_path__ + "static/media/mustardsauce@2x.938aca21.jpg";